// @flow

import React from 'react';
import Tabs from './tabs';
import { generateSlug } from '../../helpers';
import type { ACFTab } from '../../types';

type OwnProps = {
  tabs: Array<ACFTab>,
};

type Props = OwnProps;

const ACFTabs = ({
  tabs,
}: Props) => (
  <Tabs
    tabs={
      tabs.map(({ tab, rows }, index) => ({
        name: tab,
        url: `/${index > 0 ? generateSlug(tab) : ''}`,
        rows,
      }))
    }
  />
);

export default ACFTabs;
